<template>
  <b-card>
    <h4>Add note</h4>
    <b-form @submit.prevent="saveNote">
      <validation-observer ref="notesFormRef">

        <b-form-group
          label="Category"
          label-for="category"
        >
          <v-select
            id="category"
            v-model="category"
            :options="notesCategories"
          />
        </b-form-group>

        <validation-provider
          #default="{ errors }"
          name="Note"
          rules="required"
        >
          <b-form-group
            label="Note"
            label-for="note-form-text"
            class="mr-1"
          >

            <b-form-textarea
              id="note-form-text"
              v-model="noteText"
              placeholder="Enter your note"
            />

          </b-form-group>
          <span class="text-danger">{{ errors[0] }}</span>
        </validation-provider>
        <div class="d-flex justify-content-end">

          <b-button
            :disabled="submitBtnLoading"
            variant="primary"
            type="submit"
            class="mr-1"
          >
            <b-spinner
              v-if="submitBtnLoading"
              small
            />
            <span v-else>
              Save </span>
          </b-button>
        </div>
      </validation-observer>
    </b-form>
  </b-card>

</template>

<script>
import {
  BSpinner, BFormGroup, BFormTextarea, BButton, BCard, BForm,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import useSubmitNote from './hooks/useSubmitNote'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import notesStore from '@/views/driver-user-shared/notes/store'
import { max } from '@/utils/validations'

export default {
  components: {
    BForm,
    BFormGroup,
    BFormTextarea,
    BButton,
    BSpinner,
    ValidationObserver,
    ValidationProvider,
    vSelect,
    BCard,

  },
  props: {
    notableType: {
      type: String,
      default: '',
    },
  },
  setup(props, ctx) {
    useRegisterStoreModule('notes', notesStore)
    return {
      required,
      max,
      ...useSubmitNote(props, ctx),
    }
  },
}
</script>
